module.exports = __webpack_public_path__ + "static/media/Stephanie W.e348b3c2.jpg";